module.exports = __webpack_public_path__ + "media/images/sp/page_common/icon/icon_arrow_top_gray-88778fe85a453b8c1757ad47dfb68d10.svg";